import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { FeatureHistoryComponent } from "./containers/feature-claim/feature-history.component";

const routes: Routes = [
  {
    path: "",
    component: FeatureHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeatureRevisionRoutingModule {}
